var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g2, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _g3, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _g4, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtobarai({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 118,
    viewBox: "0 0 218 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1388_2618)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.688 234.646C169.22 234.646 217.48 186.386 217.48 126.854C217.48 67.3225 169.22 19.0625 109.688 19.0625C50.1565 19.0625 1.89648 67.3225 1.89648 126.854C1.89648 186.386 50.1565 234.646 109.688 234.646Z",
    fill: "#E4EFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.688 19.0743V234.646C169.215 234.646 217.48 186.393 217.48 126.854C217.48 67.3153 169.215 19.0743 109.688 19.0743Z",
    fill: "#F9DEDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192.438 32.0622C192.367 32.2158 192.284 32.3931 192.214 32.594C192.674 32.7476 192.97 32.9012 193.289 33.1849C193.88 33.7049 194.163 34.3785 194.163 35.1821C194.163 36.4703 193.454 37.4984 192.166 38.0775C191.587 38.3375 191.008 38.4675 190.015 38.5621C189.85 37.983 189.661 37.5575 189.424 37.1557C188.692 37.8412 187.77 38.2666 186.955 38.2666C185.702 38.2666 184.898 37.4275 184.898 36.0921C184.898 35.1821 185.276 34.3194 185.962 33.6221C186.387 33.1967 186.777 32.9367 187.439 32.6531C187.439 32.2867 187.439 32.1803 187.439 31.7313C187.132 31.7313 186.718 31.7234 186.198 31.7076C186.045 31.7076 185.867 31.7076 185.678 31.7076C185.525 31.7076 185.489 31.7076 185.335 31.7076L185.312 30.0295C185.926 30.1476 186.47 30.1831 187.285 30.1831H187.498C187.498 30.0807 187.51 29.9231 187.534 29.7104C187.534 29.604 187.534 29.4858 187.534 29.3677C187.534 29.1549 187.534 29.0722 187.51 28.9186L189.342 28.9895C189.259 29.3086 189.235 29.474 189.176 30.1122C190.902 30.0176 192.308 29.8286 193.171 29.5804L193.242 31.3058C193.076 31.3058 193.029 31.3058 192.781 31.3531C191.764 31.5067 190.145 31.6249 189.082 31.6722C189.082 31.7431 189.074 31.8376 189.058 31.9558C189.058 32.0149 189.058 32.0503 189.058 32.2749C189.543 32.204 189.732 32.1803 190.086 32.1803C190.287 32.1803 190.37 32.1803 190.583 32.204C190.665 31.9558 190.701 31.814 190.724 31.6013L192.426 32.0503L192.438 32.0622ZM186.576 35.9503C186.576 36.3403 186.73 36.5648 187.037 36.5648C187.238 36.5648 187.415 36.5057 187.628 36.3639C187.534 35.8203 187.475 35.1939 187.475 34.4376C186.895 34.8394 186.588 35.3594 186.588 35.9503H186.576ZM189.117 35.2412C189.519 34.7567 189.921 34.1067 190.122 33.5985C190.027 33.5985 189.992 33.5985 189.897 33.5985C189.59 33.5985 189.342 33.634 189.058 33.7167C189.058 34.4021 189.058 34.7212 189.117 35.253V35.2412ZM191.339 36.4821C191.954 36.1985 192.355 35.643 192.355 35.0521C192.355 34.5676 192.154 34.2721 191.67 34.0358C191.185 35.1703 190.594 36.033 189.803 36.813C190.5 36.7657 190.925 36.6712 191.339 36.4821Z",
    fill: "#D04942"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.741 28.9186C199.789 29.6158 200.025 30.8922 200.344 32.074C200.817 31.9085 201.136 31.8022 201.573 31.684C202.243 31.487 202.708 31.3491 202.968 31.2704C203.216 31.1994 203.251 31.1876 203.405 31.1167L204.008 33.0076C202.956 33.1612 201.467 33.563 200.202 34.0003C198.843 34.4848 198.134 35.0403 198.134 35.6666C198.134 36.293 198.772 36.6003 200.249 36.6003C201.219 36.6003 202.4 36.4703 203.369 36.2575C203.523 36.2221 203.629 36.1985 203.937 36.0921L204.079 38.113C203.819 38.113 203.7 38.1366 203.157 38.1957C201.975 38.3257 201.254 38.373 200.474 38.373C198.938 38.373 197.862 38.1484 197.165 37.6993C196.562 37.3093 196.184 36.5412 196.184 35.7021C196.184 34.863 196.586 34.0594 197.283 33.5158C197.661 33.2203 197.969 33.0431 198.619 32.7121C198.359 31.7903 198.311 31.5304 197.992 29.9113C197.886 29.4267 197.874 29.3558 197.827 29.214L199.765 28.9304L199.741 28.9186Z",
    fill: "#D04942"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M206.076 30.0414C206.253 30.0414 206.395 30.0414 206.477 30.0414C206.749 30.0414 207.139 30.0177 208.297 29.9468C209.834 29.8523 210.862 29.7932 212.883 29.7223L213.982 29.675L214.431 29.6514C214.797 29.6514 214.856 29.6277 214.916 29.6277C214.986 29.6277 215.034 29.6277 215.164 29.5805L215.258 31.5068C215.105 31.4832 215.069 31.4832 214.963 31.4832C214.218 31.4832 213.261 31.7668 212.528 32.2277C211.465 32.8777 210.838 33.7758 210.838 34.6386C210.838 35.2531 211.122 35.6667 211.736 35.9622C212.162 36.1749 213.096 36.3404 213.769 36.3404C213.852 36.3404 213.935 36.3404 214.088 36.3404L213.84 38.3612C213.686 38.3258 213.663 38.3258 213.45 38.3021C212.233 38.1958 211.441 38.0185 210.756 37.7112C209.503 37.1203 208.853 36.1513 208.853 34.7922C208.853 33.9058 209.148 33.114 209.763 32.3931C210.035 32.0504 210.295 31.8377 210.803 31.4832L210.307 31.5304C210.07 31.5541 209.704 31.5777 207.707 31.7432C206.714 31.8495 206.667 31.8495 206.206 31.9441L206.099 30.0059L206.076 30.0414ZM213.616 32.4641C214.041 32.9486 214.36 33.4213 214.644 34.0122L213.627 34.4849C213.296 33.8113 213.025 33.3977 212.599 32.9131L213.616 32.4759V32.4641ZM215.046 31.8495C215.424 32.275 215.731 32.6886 216.086 33.3504L215.093 33.8113C214.715 33.1022 214.443 32.6886 214.076 32.275L215.034 31.8495H215.046Z",
    fill: "#D04942"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.868 103.183L122.617 93.1967L123.491 92.3222L128.963 92.2631C128.963 92.2631 130.038 82.9505 133.915 81.5796C133.915 81.5796 140.19 79.1806 142.577 85.7986L143.712 91.3885H149.644L150.554 92.5231L153.225 103.1L120.868 103.171V103.183Z",
    fill: "#72AEF4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.476 32.0031C164.476 32.0031 164.63 39.7439 164.004 41.6466C164.004 41.6466 164.642 46.8583 158.792 49.2338L156.735 49.8601L156.984 54.221L158.355 54.8473C158.355 54.8473 161.475 53.2873 165.894 57.53C170.326 61.7726 171.26 68.1898 171.319 70.6243C171.378 73.0588 171.508 76.746 171.508 76.746L173.86 80.4569L174.498 82.265L176.082 82.5014C176.082 82.5014 177.878 82.4896 178.646 84.7823C179.414 87.0749 179.414 87.8077 179.414 87.8077L178.067 87.9613L180.206 93.6694L179.651 95.3357L171.331 97.6284L169.83 96.7539L168.447 90.514L166.154 89.6158V88.2095L165.339 86.8977L164.654 85.7868L164.287 91.7903C164.287 91.7903 166.131 92.3694 166.344 93.2085C166.556 94.0476 165.292 95.8912 165.292 95.8912L157.622 96.9548H152.008L150.448 91.814L142.282 91.9321L149.479 103.396L142.164 103.029L140.013 100.784L134.849 92.5467C134.849 92.5467 131.693 85.8341 131.232 83.7068L130.901 75.777C130.901 75.777 131.114 68.7216 132.851 64.7035C134.589 60.6854 138.063 54.0673 144.468 54.3864L146.856 54.5991L147.837 53.7246V50.581L147.293 46.7756L142.412 44.6011L142.199 28.635L153.816 23.8605L161.853 25.1605L164.476 31.9559V32.0031Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.775 49.7773H157.752C157.752 49.7773 157.279 49.9545 157.775 49.7773Z",
    fill: "#7CA6FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M165.989 35.7849L166.06 33.7759C168.648 31.2114 166.261 27.4651 166.261 27.4651L165.729 26.1414L163.956 23.0451C162.184 19.9488 156.7 18.9679 153.332 18.6134C149.964 18.2588 146.43 20.3861 146.43 20.3861C144.48 20.3034 142.708 21.4497 140.32 24.1915C137.933 26.9332 137.224 38.0894 137.224 38.0894C137.224 38.0894 137.141 38.5267 136.255 41.0085C135.369 43.4902 135.723 48.0874 139.978 49.8601C144.232 51.6328 145.024 49.6001 145.024 49.6001L147.99 50.4392L147.447 46.6338L146.702 45.972C146.702 45.972 146.088 42.1666 145.461 40.3939C144.847 38.6212 145.166 35.7613 145.166 35.7613C146.596 35.8086 146.052 35.7022 148.309 34.6386C152.528 34.4849 159.406 34.2604 162.94 34.0359C163.566 34.0004 164.595 38.1958 164.145 41.4694C163.696 44.7429 162.81 47.922 159.714 49.0802C158.615 49.482 157.421 49.8247 157.149 49.931C156.086 52.271 162.349 50.4629 164.677 48.9029C167.065 47.3075 167.691 43.7739 167.596 42.1784C167.514 40.583 166.001 35.8086 166.001 35.8086L165.989 35.7849Z",
    fill: "#72AEF4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M151.524 96.9666L153.226 103.1H166.639L165.788 95.5484C165.788 95.5484 163.708 96.3048 160.588 96.5884C157.468 96.872 151.524 96.9666 151.524 96.9666Z",
    fill: "#D7D7D7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M163.921 43.0412C163.566 47.0239 160.116 49.1747 157.055 49.8247C153.923 50.4865 149.101 48.702 147.423 46.2202",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M164.157 41.1266C164.713 39.5193 164.417 38.0066 164.606 36.3167",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M166.202 27.8431C168.565 31.2585 166.911 33.563 165.835 34.4376",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M158.674 28.4932C158.768 32.5349 155.164 34.2722 152.41 34.1304",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151.855 28.0914C151.642 32.3459 149.16 34.5204 145.969 35.8795",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M146.217 31.7312C144.965 34.2839 144.61 37.2739 145.248 40.0511C145.603 41.5992 147.766 45.9128 145.827 48.17",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M165.871 35.7377C167.325 40.4294 169.227 48.3711 162.373 49.7893",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M165.127 25.3024C163.957 21.1661 155.897 16.5807 147.411 19.8543",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M145.851 20.8942C137.496 20.7642 137.697 36.8485 136.846 39.2121C133.466 48.6074 142.034 52.2828 145.107 49.9428",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M147.967 46.8702C147.99 49.1629 148.014 51.4674 148.037 53.7601C147.872 53.961 147.695 54.1619 147.529 54.351",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M160.056 39.6021C160.67 39.6021 161.167 39.0624 161.167 38.3966C161.167 37.7309 160.67 37.1912 160.056 37.1912C159.443 37.1912 158.946 37.7309 158.946 38.3966C158.946 39.0624 159.443 39.6021 160.056 39.6021Z",
    fill: "#313131"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M151.134 39.8149C151.747 39.8149 152.245 39.2752 152.245 38.6094C152.245 37.9437 151.747 37.404 151.134 37.404C150.52 37.404 150.023 37.9437 150.023 38.6094C150.023 39.2752 150.52 39.8149 151.134 39.8149Z",
    fill: "#313131"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M155.755 41.9658L155.979 42.6039",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M157.87 44.9912C156.629 46.1612 155.163 46.1021 153.722 45.1094",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M163.094 28.2806C163.909 32.7241 160.494 34.0714 158.946 34.6623",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M132.107 91.0576C132.107 91.0576 131.847 87.2404 133.336 85.4086C134.66 83.7777 138.453 82.265 139.931 84.8649C140.592 86.0349 141.833 88.954 142.53 91.6721L144.173 91.4712C144.173 91.4712 142.731 81.2841 136.976 81.1305C131.221 80.9768 129.684 87.6776 129.684 87.6776L132.107 91.0576Z",
    fill: "#72AEF4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M145.308 54.351C134.908 54.0083 131.398 66.6417 131.552 74.9261",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M142.294 67.2916C140.191 69.9979 139.706 73.5906 139.281 77.006C139.139 78.1878 138.997 79.3814 138.844 80.5632",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M140.853 86.5668C142.318 91.5067 144.729 96.163 147.896 100.228C149.881 102.769 151.051 106.09 152.576 108.926",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M147.577 100.193C146.418 101.493 144.232 102.757 142.507 102.982",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M142.53 104.069C143.298 106.267 143.7 108.607 143.7 110.936",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M164.311 65.7317L164.748 74.2879",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M152.28 96.9667C154.986 96.9667 161.959 96.8958 164.181 96.2458C164.831 96.0567 165.493 95.8085 165.918 95.2885C167.561 93.2558 166.533 92.6413 164.464 91.3531",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M165.398 95.9502C165.67 98.1957 166.297 104.14 166.568 106.386C166.852 108.749 167.136 111.113 167.419 113.464",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1388_2618",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 16,
    width: 217,
    height: 217
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M109.688 232.283C169.22 232.283 217.48 184.022 217.48 124.491C217.48 64.9589 169.22 16.6988 109.688 16.6988C50.1565 16.6988 1.89648 64.9589 1.89648 124.491C1.89648 184.022 50.1565 232.283 109.688 232.283Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1388_2618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.74 103.644H-0.845215V124.101H217.74V103.644Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.20435 103.336H228.92",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M64.307 111.184L34.0884 107.686L34.2538 86.5668L44.9964 77.7388L74.2695 80.5278L74.5177 104.684L64.8861 110.853",
    fill: "#FCECD2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7065 94.5084C87.7065 94.5084 90.011 116.785 90.3774 123.545L47.0645 123.392L51.1298 109.99L64.236 111.184L74.6358 104.14V100.027L76.9049 98.0775L78.5239 94.8275L87.7065 94.5084Z",
    fill: "#72AEF4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M158.804 56.6082C156.7 59.3382 150.058 58.6291 146.206 56.6082",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M158.402 54.5873C161.404 53.89 164.677 55.9582 166.887 58.2272C169.097 60.4963 170.385 63.628 171.023 66.8189C171.662 70.0098 171.709 73.2952 171.744 76.5569",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4127 36.7304C56.4127 36.7304 56.7318 45.0857 58.4572 46.6575C60.1944 48.2293 62.558 49.4938 62.558 49.4938L63.8226 49.9665L64.248 51.7865L62.9008 51.9519L60.7026 54.5755L58.5872 55.7573L57.1572 56.0055L53.7773 58.0382C53.7773 58.0382 51.7446 61.2527 51.4137 62.6827C51.071 64.1127 47.3601 78.0933 47.3601 78.0933C47.3601 78.0933 70.0506 79.9015 74.0333 80.8706C74.636 85.2196 74.1869 87.9141 74.7542 90.644C71.977 88.9541 67.0252 90.2777 65.938 91.4831C66.9071 92.4522 70.8424 92.6767 71.7288 92.8067C67.2616 94.863 63.6926 93.1731 63.3971 95.0994C63.6335 97.8766 63.8816 97.9948 64.6025 99.803C66.6589 101.493 68.3252 101.977 70.7361 101.363C75.1087 100.252 78.3941 96.3521 78.3941 96.3521C78.3941 96.3521 91.3466 88.9304 91.3466 84.4278C91.3466 79.9251 90.5667 70.8016 89.3376 66.4999C88.1085 62.1981 87.2931 55.8755 78.9141 55.4619C78.9141 55.4619 75.026 51.172 72.1661 50.7583L73.1824 45.8539C73.1824 45.8539 73.3833 42.3794 74.6124 40.5358C75.8414 38.6922 75.8415 37.0613 75.8415 37.0613L78.2996 29.0841L61.1281 25.6097L55.4082 32.145L56.3891 36.6949L56.4127 36.7304Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M172.95 78.8614C173.352 79.7596 173.765 80.6459 174.167 81.5441",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M178.635 84.5932C178.729 84.865 178.824 85.1368 178.906 85.3968C179.048 85.8222 179.19 86.2595 179.143 86.6968C179.095 87.134 178.8 87.5831 178.351 87.654C177.996 87.7131 177.642 87.5004 177.417 87.2286C177.193 86.9568 177.075 86.6022 176.968 86.2595C176.732 85.5386 175.337 83.0805 176.235 82.4541C177.335 81.686 178.375 83.8368 178.623 84.5814L178.635 84.5932Z",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2961 47.662C59.2961 47.662 58.4216 51.1719 54.9116 49.1274C51.4017 47.0829 55.0416 38.8339 55.3489 36.5649C55.6443 34.4258 54.7698 34.2249 54.7698 34.2249C54.7698 34.2249 51.5553 31.4477 55.5025 26.1887C55.5025 26.1887 58.1379 19.9015 65.7251 19.1806C73.3122 18.4597 75.2267 21.0833 75.2267 21.0833C75.2267 21.0833 78.2994 19.9133 81.2185 22.6906C84.1375 25.4678 85.7448 28.5405 85.6029 34.2367C85.4611 39.933 85.0711 39.5548 85.0711 39.5548C85.0711 39.5548 86.7965 42.9939 85.7566 46.8583C84.7166 50.7228 80.8048 53.1219 77.0822 49.2692C77.0822 49.2692 75.4986 50.581 73.4304 50.1674L73.0168 47.0002L74.6713 45.9011C74.6713 45.9011 73.7731 44.5184 74.5295 41.3512C75.2858 38.1839 75.4276 37.4985 75.4276 37.4985C75.4276 37.4985 72.9813 36.6831 72.7095 35.1704C72.7095 35.1704 69.0223 35.844 63.6569 35.1585C59.5325 35.3004 57.4998 35.3004 57.4998 35.3004L56.507 35.2294C56.507 35.2294 55.9871 44.9202 59.3079 47.6738L59.2961 47.662Z",
    fill: "#72AEF4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M176.022 82.8087L175.68 81.8869L167.407 83.8132L167.643 84.9123",
    stroke: "#313131",
    strokeWidth: 0.945439,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M168.719 90.4904L169.901 96.5058L171.118 97.4394L179.544 95.1822L180.1 93.7876L177.866 87.7841",
    stroke: "#313131",
    strokeWidth: 0.945439,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M167.443 87.5477C168.188 87.3468 169.145 87.4059 169.771 87.7014C170.256 87.9377 170.752 88.3513 170.728 88.8832C170.717 89.1904 170.527 89.4741 170.279 89.6513C170.031 89.8286 169.736 89.935 169.428 90.0059C168.885 90.124 168.329 90.1713 167.774 90.124C167.136 90.065 166.415 89.8168 166.214 89.2141C166.025 88.635 166.427 87.9968 166.97 87.725C167.112 87.6541 167.266 87.595 167.443 87.5477Z",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M168.955 87.3823C169.617 87.1578 169.581 87.0632 169.853 86.7087C170.125 86.3542 170.113 85.8224 169.841 85.4796C169.534 85.0778 168.967 84.9596 168.459 84.9242C167.903 84.8887 167.336 84.9006 166.816 85.1133C166.296 85.326 165.847 85.7396 165.717 86.2833C165.587 86.8269 165.847 87.465 166.367 87.666C166.32 87.6423 166.249 87.7014 166.261 87.7605",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M164.264 93.0312C164.287 90.3485 164.63 80.7878 164.973 78.2942",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M143.795 91.4003C143.795 91.4003 143.168 80.0669 135.912 81.225C128.739 82.3714 129.483 91.3885 129.483 91.3885",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M153.214 102.675L150.909 92.6176C150.708 91.8139 149.799 91.2467 148.77 91.2821L144.138 91.3412",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M133.253 91.8375L124.378 92.2157C123.338 92.2511 122.475 92.8775 122.369 93.6929L121.116 102.58",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M170.078 89.2495L170.704 89.0722L171.804 92.8067L171.177 92.984L170.078 89.2495ZM171.012 88.9777L171.319 88.8831L172.418 92.6176L172.111 92.7122L171.012 88.9777ZM171.638 88.8004L172.572 88.5286L173.671 92.2631L172.737 92.5349L171.638 88.8004ZM172.879 88.434L173.186 88.3395L174.285 92.074L173.978 92.1685L172.879 88.434ZM173.813 88.1622L174.439 87.985L175.538 91.7194L174.912 91.8967L173.813 88.1622ZM174.746 87.8904L175.68 87.6186L176.779 91.3531L175.845 91.6249L174.746 87.8904ZM175.987 87.5241L176.294 87.4295L177.393 91.164L177.086 91.2585L175.987 87.5241Z",
    fill: "#313131"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M170.256 96.1985L179.379 93.6931",
    stroke: "#313131",
    strokeWidth: 0.590899,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M156.984 50.3801C156.913 51.9046 156.688 52.6964 157.196 54.15",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M141.514 41.2685C141.514 41.2685 139.434 48.702 147.399 50.4156",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M122.995 94.3666L123.35 102.675",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M132.154 91.6248C132.154 91.6248 131.043 85.0068 136.22 83.4941C139.458 82.5486 140.261 84.9949 140.805 86.2595",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M132.603 87.5594C133.088 88.9421 133.679 90.3012 134.352 91.6012C136.61 95.9738 138.926 99.1292 142.034 102.946",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M131.41 77.3723C131.115 79.4759 131.209 80.965 131.575 83.045",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M182.983 80.5633L186.576 72.8107C186.068 71.9952 185.607 71.1207 185.241 70.1989C181.955 61.8909 186.021 52.4956 194.329 49.2102C202.637 45.9248 212.032 49.9901 215.317 58.2982C218.603 66.6062 214.537 76.0015 206.229 79.2869C200.84 81.4142 195.002 80.4451 190.665 77.2306L182.983 80.5633Z",
    fill: "#F2DDFF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M182.983 80.5633L186.576 72.8107C186.068 71.9952 185.607 71.1207 185.241 70.1989C181.955 61.8909 186.021 52.4956 194.329 49.2102C202.637 45.9248 212.032 49.9901 215.317 58.2982C218.603 66.6062 214.537 76.0015 206.229 79.2869C200.84 81.4142 195.002 80.4451 190.665 77.2306L182.983 80.5633Z",
    fill: "#FFC860"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1388_2618",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 182,
    y: 48,
    width: 35,
    height: 33
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M182.983 80.5633L186.576 72.8107C186.068 71.9952 185.607 71.1207 185.241 70.1989C181.955 61.8909 186.021 52.4956 194.329 49.2102C202.637 45.9248 212.032 49.9901 215.317 58.2982C218.603 66.6062 214.537 76.0015 206.229 79.2869C200.84 81.4142 195.002 80.4451 190.665 77.2306L182.983 80.5633Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1388_2618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.092 55.5328H192.946C192.032 55.5328 191.291 56.2736 191.291 57.1874V83.1278C191.291 84.0416 192.032 84.7824 192.946 84.7824H207.092C208.006 84.7824 208.746 84.0416 208.746 83.1278V57.1874C208.746 56.2736 208.006 55.5328 207.092 55.5328Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.494 57.2464H192.521V81.107H207.494V57.2464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.317 63.4863H195.44V70.2226H194.317V63.4863ZM196.007 63.4863H196.574V70.2226H196.007V63.4863ZM197.13 63.4863H198.82V70.2226H197.13V63.4863ZM199.375 63.4863H199.942V70.2226H199.375V63.4863ZM201.065 63.4863H202.188V70.2226H201.065V63.4863ZM202.755 63.4863H204.445V70.2226H202.755V63.4863ZM205 63.4863H205.568V70.2226H205V63.4863Z",
    fill: "#2F3748"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M182.983 80.5633L186.576 72.8107C186.068 71.9952 185.607 71.1207 185.241 70.1989C181.955 61.8909 186.021 52.4956 194.329 49.2102C202.637 45.9248 212.032 49.9901 215.317 58.2982C218.603 66.6062 214.537 76.0015 206.229 79.2869C200.84 81.4142 195.002 80.4451 190.665 77.2306L182.983 80.5633Z",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M205.863 128.332L196.893 111.444L192.402 108.359L190.712 106.764L188.821 102.97L187.722 101.576L188.821 100.181L190.819 101.871L188.526 97.8884L187.427 97.4866C187.427 97.4866 182.747 97.3921 181.542 94.2958C181.542 94.2958 183.74 92.204 186.328 90.7031C188.916 89.2022 189.519 89.0131 189.519 89.0131C189.519 89.0131 192.509 89.6159 193.005 90.8095C193.501 92.0031 193.702 94.4967 193.702 94.4967L194.6 96.0921C194.6 96.0921 197.094 95.9976 198.985 97.7821C200.876 99.5784 202.069 100.37 202.672 103.266C203.275 106.161 203.074 107.059 204.563 111.136L213.19 127.28L205.851 128.332H205.863Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M183.208 95.9621L184.992 93.953L191.421 90.0767L190.145 88.8122L181.979 93.4803L181.742 94.7212L183.208 95.9621Z",
    fill: "#D7D7D7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M195.711 97.6521L194.139 95.2648C194.139 95.2648 193.442 93.4567 193.489 92.7594C193.537 92.0621 193.395 90.7031 191.232 89.5567C189.081 88.3986 189.483 88.954 189.483 88.954C189.483 88.954 183.22 92.5585 182.321 93.4094C181.423 94.2603 182.026 95.0639 183.078 95.8203C184.13 96.5766 186.032 97.1675 187.285 97.2739C188.538 97.3802 189.542 99.2239 189.944 100.134C190.05 100.382 190.346 100.937 190.748 101.67",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M190.533 95.1001C191.262 94.6166 191.765 94.0924 191.657 93.9293C191.549 93.7661 190.87 94.0258 190.141 94.5092C189.412 94.9927 188.909 95.517 189.018 95.6801C189.126 95.8433 189.804 95.5836 190.533 95.1001Z",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M183.444 96.1393C183.444 96.1393 183.48 95.1466 184.213 94.5675C184.945 93.9885 191.386 90.124 191.386 90.124",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M186.812 87.7486L186.612 85.0659",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M184.851 88.7294L183.267 86.6731",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M182.77 90.0177L180.773 88.2213",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M189.176 103.076C190.228 104.53 190.606 106.385 191.847 107.733C192.627 108.584 193.679 109.139 194.66 109.742C198.075 111.834 203.511 124.727 205.638 128.119",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M189.211 100.512C188.916 99.543 187.923 100.796 187.97 101.387C188.041 102.107 188.762 102.521 189.176 103.088",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M189.353 100.477C190.003 101.138 193.052 103.561 194.648 103.478C195.664 103.431 196.101 98.6094 195.818 97.5576",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M202.448 103.207C202.542 103.892 202.578 104.589 202.684 105.263C202.991 107.378 203.795 109.423 204.787 111.396C205.851 113.512 212.339 125.082 213.415 127.067",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M195.274 96.1275C197.803 96.3875 201.065 99.1174 202.01 101.434C202.247 102.001 202.365 102.604 202.448 103.206",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M197.543 97.3329C197.543 97.3329 197.721 100.796 197.366 102.344",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M199.458 98.3022C199.458 98.3022 199.552 101.458 199.079 103.266",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M201.384 100.512C201.384 100.512 201.23 102.793 200.958 103.608",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M204.752 111.727L198.843 114.883",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2249 76.5569L34.2777 68.9698C34.7504 68.1307 35.164 67.2444 35.4831 66.2989C38.3785 57.8491 33.8759 48.6428 25.426 45.7474C16.9761 42.852 7.76993 47.3547 4.87453 55.8046C1.97912 64.2544 6.48177 73.4606 14.9316 76.356C20.4152 78.2351 26.1942 76.9824 30.3777 73.5788L38.2131 76.5451L38.2249 76.5569Z",
    fill: "#FFC860"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1388_2618",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 44,
    width: 36,
    height: 34
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1065 76.5923L34.1593 69.0052C34.632 68.1661 35.0456 67.2798 35.3647 66.3343C38.2601 57.8845 33.7575 48.6783 25.3076 45.7829C16.8577 42.8874 7.65152 47.3901 4.75612 55.84C1.86071 64.2898 6.36336 73.496 14.8132 76.3914C20.2968 78.2705 26.0758 77.0178 30.2593 73.6142L38.0947 76.5805L38.1065 76.5923Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1388_2618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0921 51.9992H12.946C12.0323 51.9992 11.2915 52.7399 11.2915 53.6537V79.5942C11.2915 80.5079 12.0323 81.2487 12.946 81.2487H27.0921C28.0059 81.2487 28.7467 80.5079 28.7467 79.5942V53.6537C28.7467 52.7399 28.0059 51.9992 27.0921 51.9992Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4944 53.7128H12.521V77.5733H27.4944V53.7128Z",
    fill: "white"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4571 58.5108L23.0035 62.659C22.968 62.7535 22.8616 62.8244 22.7553 62.8244H17.4372C17.319 62.8244 17.2245 62.7535 17.189 62.659L15.6763 58.4872C15.6172 58.3336 15.7472 58.1799 15.9245 58.1799H24.2089C24.3862 58.1918 24.5162 58.3454 24.4571 58.499V58.5108Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2125 63.0372H22.8142L24.5751 58.0973H15.428L17.2125 63.0372Z",
    fill: "#C1F2FF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0587 62.9545L15.936 64.5499H23.6886",
    stroke: "#2F3748",
    strokeWidth: 0.945439,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4013 67.2445C17.943 67.2445 18.3822 66.8053 18.3822 66.2636C18.3822 65.7218 17.943 65.2827 17.4013 65.2827C16.8596 65.2827 16.4204 65.7218 16.4204 66.2636C16.4204 66.8053 16.8596 67.2445 17.4013 67.2445Z",
    fill: "#2F3748"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4594 67.2445C23.0011 67.2445 23.4403 66.8053 23.4403 66.2636C23.4403 65.7218 23.0011 65.2827 22.4594 65.2827C21.9177 65.2827 21.4785 65.7218 21.4785 66.2636C21.4785 66.8053 21.9177 67.2445 22.4594 67.2445Z",
    fill: "#2F3748"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4517 58.1799H24.4688L22.8498 62.9543H17.0589L15.1208 56.5608H13.7026",
    stroke: "#2F3748",
    strokeWidth: 0.945439,
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4204 60.449H23.3694",
    stroke: "#2F3748",
    strokeWidth: 0.827259,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7251 58.4282V62.8008",
    stroke: "#2F3748",
    strokeWidth: 0.827259,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1482 58.4282V62.8008",
    stroke: "#2F3748",
    strokeWidth: 0.827259,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2249 76.5569L34.2777 68.9698C34.7504 68.1307 35.164 67.2444 35.4831 66.2989C38.3785 57.8491 33.8759 48.6428 25.426 45.7474C16.9761 42.852 7.76993 47.3547 4.87453 55.8046C1.97912 64.2544 6.48177 73.4606 14.9316 76.356C20.4152 78.2351 26.1942 76.9824 30.3777 73.5788L38.2131 76.5451L38.2249 76.5569Z",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8706 70.0097H15.0381V73.0942H24.8706V70.0097Z",
    fill: "#C1F2FF",
    stroke: "#2F3748",
    strokeWidth: 0.945439,
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M140.722 88.8477H79.7177C78.693 88.8477 77.8623 89.6784 77.8623 90.7031V109.588C77.8623 110.613 78.693 111.444 79.7177 111.444H140.722C141.747 111.444 142.578 110.613 142.578 109.588V90.7031C142.578 89.6784 141.747 88.8477 140.722 88.8477Z",
    fill: "#FFF9DB",
    stroke: "#383838",
    strokeWidth: 1.1818,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6255 98.3375C90.531 98.4793 90.4955 98.562 90.401 98.8929C89.9755 100.299 89.3256 101.54 88.5101 102.45C87.6592 103.419 86.6429 104.14 85.2247 104.79C84.9647 104.329 84.8465 104.176 84.4447 103.821C85.3665 103.443 85.8865 103.171 86.4656 102.734C87.7892 101.753 88.6519 100.5 89.1601 98.8457L86.3829 98.8929C85.8156 99.7911 85.1065 100.583 84.2202 101.257C83.9484 100.878 83.8066 100.76 83.322 100.465C84.3738 99.7438 85.0356 99.0111 85.7093 97.7939C85.9929 97.2739 86.1465 96.9075 86.182 96.5766L87.4465 96.8248C87.4071 96.8799 87.3559 96.9745 87.2929 97.1084C87.2929 97.1084 87.2692 97.1557 87.1747 97.3684C87.1747 97.3684 87.1353 97.4472 87.0565 97.6048C86.9777 97.7623 86.9304 97.8608 86.9147 97.9002C87.0329 97.9002 87.1865 97.8766 87.3519 97.8766L89.3728 97.853C89.7274 97.853 89.8337 97.8293 90.0464 97.7584L90.6373 98.3375H90.6255Z",
    fill: "#2C2C2C",
    stroke: "#2C2C2C",
    strokeWidth: 0.23636,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9277 96.9902C94.8923 97.2384 94.8805 97.4747 94.8686 97.9238L94.8214 103.183C95.7786 102.994 96.6413 102.651 97.3386 102.166C98.1895 101.587 98.7567 100.949 99.2177 100.051C99.5722 100.536 99.7022 100.654 100.092 100.997C99.454 101.977 98.8631 102.592 98.0359 103.147C97.114 103.762 96.1804 104.128 94.6795 104.412C94.4314 104.459 94.325 104.495 94.1241 104.566L93.5332 103.856C93.5923 103.608 93.6159 103.443 93.6159 102.911L93.6514 97.9357C93.6514 97.5023 93.6356 97.1872 93.6041 96.9902H94.9159H94.9277Z",
    fill: "#2C2C2C",
    stroke: "#2C2C2C",
    strokeWidth: 0.23636,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M109.133 98.7866C109.062 98.952 109.038 99.082 109.026 99.4011C109.003 100.441 108.896 101.859 108.802 102.474C108.565 104.069 108.235 104.447 107.135 104.447C106.781 104.447 106.474 104.424 105.989 104.341C105.965 103.762 105.942 103.585 105.776 103.159C106.32 103.301 106.686 103.372 106.994 103.372C107.384 103.372 107.525 103.171 107.679 102.367C107.785 101.729 107.88 100.477 107.88 99.4129H105.729C105.599 100.571 105.41 101.268 104.996 102.06C104.488 103.041 103.673 103.88 102.503 104.613C102.196 104.128 102.066 103.975 101.676 103.632C102.822 103.029 103.578 102.297 104.075 101.316C104.323 100.807 104.465 100.358 104.547 99.7084C104.571 99.5784 104.583 99.4838 104.595 99.4247H103.07C102.503 99.4247 102.385 99.4484 102.077 99.4838V98.3493C102.385 98.4084 102.633 98.4202 103.094 98.4202H104.713C104.736 98.0657 104.76 97.5221 104.76 97.2621V97.0257C104.76 96.9075 104.76 96.8366 104.736 96.6712L105.965 96.6948C105.942 96.813 105.942 96.8484 105.93 96.9784C105.93 97.0375 105.93 97.0848 105.93 97.1557C105.914 97.2818 105.902 97.5063 105.895 97.8293C105.895 98.0302 105.895 98.113 105.859 98.4084H107.904C108.317 98.4084 108.4 98.3848 108.636 98.3139L109.156 98.7748L109.133 98.7866Z",
    fill: "#2C2C2C",
    stroke: "#2C2C2C",
    strokeWidth: 0.23636,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M112.465 97.4629C112.418 97.8056 112.395 98.2547 112.395 98.8693C112.395 99.6729 112.465 100.772 112.572 101.339C112.725 102.296 113.021 102.887 113.316 102.887C113.458 102.887 113.588 102.746 113.695 102.486C113.919 101.989 114.085 101.434 114.179 100.819C114.498 101.186 114.652 101.327 115.101 101.658C114.616 103.455 114.085 104.199 113.305 104.199C112.69 104.199 112.194 103.75 111.815 102.864C111.437 101.942 111.272 100.607 111.236 98.0538C111.236 97.7347 111.236 97.6638 111.201 97.4629H112.465ZM116.826 97.8765C117.984 99.2711 118.634 100.807 118.894 102.828L117.748 103.266C117.689 102.403 117.476 101.446 117.157 100.607C116.85 99.7674 116.401 99.0229 115.845 98.3374L116.814 97.8765H116.826Z",
    fill: "#2C2C2C",
    stroke: "#2C2C2C",
    strokeWidth: 0.23636,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M122.487 98.5147C122.346 99.0229 122.192 99.8738 122.074 100.784C122.058 100.87 122.042 100.961 122.026 101.056L122.05 101.079C122.582 100.559 123.728 100.205 124.839 100.205C126.411 100.205 127.439 100.973 127.439 102.155C127.439 102.828 127.085 103.514 126.494 103.927C125.891 104.365 125.135 104.554 124.059 104.554C123.267 104.554 122.759 104.495 121.707 104.235C121.707 103.667 121.684 103.478 121.566 103.041C122.464 103.36 123.267 103.502 124.047 103.502C125.347 103.502 126.246 102.958 126.246 102.178C126.246 101.564 125.666 101.197 124.686 101.197C123.87 101.197 123.007 101.446 122.393 101.871C122.227 101.989 122.168 102.048 121.979 102.273L120.821 102.237C120.845 102.072 120.845 102.036 120.892 101.682C120.963 101.115 121.116 100.087 121.282 98.9993C121.317 98.7747 121.329 98.6684 121.341 98.4675L122.487 98.5265V98.5147ZM122.606 96.7066C123.244 97.0611 125.005 97.5811 126.045 97.7347L125.666 98.7984C124.095 98.4438 123.126 98.1365 122.074 97.652L122.606 96.7184V96.7066Z",
    fill: "#2C2C2C",
    stroke: "#2C2C2C",
    strokeWidth: 0.23636,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M134.565 96.8838C134.53 97.1556 134.53 97.2266 134.518 97.9711C134.92 97.9711 135.345 97.9711 135.794 97.9711C135.546 97.4511 135.31 97.0729 134.955 96.6475L135.617 96.352C135.971 96.7775 136.22 97.1675 136.468 97.7111L135.889 97.9829C136.078 97.9829 136.101 97.9829 136.302 97.9829C136.799 97.9829 136.94 97.9829 137.189 97.9474V99.0111C136.87 98.9874 136.373 98.9638 135.664 98.9638C135.546 98.9638 135.172 98.9638 134.541 98.9638V100.571C134.742 100.996 134.837 101.375 134.837 101.871C134.837 102.887 134.352 103.75 133.466 104.365C133.076 104.625 132.651 104.814 131.8 105.109C131.551 104.566 131.433 104.376 131.15 104.069C132.65 103.809 133.643 103.112 133.785 102.19C133.513 102.616 133.04 102.84 132.426 102.84C132.001 102.84 131.681 102.734 131.362 102.509C130.925 102.19 130.724 101.788 130.724 101.268C130.724 100.287 131.492 99.5902 132.544 99.5902C132.946 99.5902 133.289 99.6965 133.501 99.862C133.501 99.8383 133.501 99.8147 133.501 99.8029V99.7438C133.501 99.4956 133.501 99.2356 133.501 98.9638C132.391 98.9874 131.599 99.0229 131.15 99.0465C129.601 99.1529 129.531 99.1529 129.271 99.2002L129.235 98.0893C129.436 98.1129 129.519 98.1129 129.684 98.1129C129.921 98.1129 130.062 98.1129 131.256 98.0656C131.693 98.0656 132.45 98.042 133.49 98.0065V97.4275C133.466 97.1438 133.466 97.0729 133.43 96.8838H134.589H134.565ZM131.788 101.174C131.788 101.587 132.119 101.895 132.568 101.895C133.076 101.895 133.466 101.54 133.466 101.067C133.466 100.89 133.407 100.748 133.289 100.654C133.135 100.512 132.91 100.429 132.686 100.429C132.166 100.429 131.788 100.748 131.788 101.174ZM137.13 97.7702C136.858 97.2147 136.621 96.8366 136.314 96.4466L136.929 96.1629C137.283 96.5647 137.531 96.9547 137.78 97.4393L137.13 97.7702Z",
    fill: "#2C2C2C",
    stroke: "#2C2C2C",
    strokeWidth: 0.23636,
    strokeMiterlimit: 10
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.535 23.2223C158.438 9.48983 135.003 1.40632 109.688 1.40632C82.6961 1.40632 57.8547 10.6007 38.1187 26.0114",
    stroke: "url(#paint0_linear_1388_2618)",
    strokeWidth: 2.3636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.196 27.5596C181.258 24.546 179.202 20.3506 178.481 17.0061L176.744 22.726L171.745 25.9996C175.16 25.7514 179.769 26.5432 183.196 27.5596Z",
    fill: "url(#paint1_linear_1388_2618)"
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0629 41.1739C56.5074 39.5667 56.8029 38.054 56.6138 36.364",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0938 25.3614C57.2637 21.2251 67.7936 16.3797 73.8089 19.9133",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7871 50.1556C64.2244 51.5619 64.3426 53.0628 64.1416 54.5164",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4661 51.1246C74.7424 51.4437 75.8769 52.2001 76.8224 53.1219C77.7678 54.0437 78.536 55.1073 79.316 56.1827C79.316 56.1827 76.1487 64.8453 72.8279 65.2944C69.507 65.7435 67.9707 61.9854 67.9707 61.9854",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8252 54.1973C73.1235 57.0336 70.5353 59.3145 67.5217 60.6499",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2188 91.0103L34.2542 86.5668L44.8668 77.9396L74.2699 81.1896L74.3054 90.3485",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9777 92.2394C32.824 93.2203 32.824 94.0002 32.7886 94.9929C32.7531 95.7966 32.7886 96.6593 33.2377 97.3211C33.6867 97.9829 34.7267 98.3138 35.3176 97.7702C35.7076 97.4156 35.7785 96.7538 35.4594 96.3284C35.1404 95.9029 34.5967 95.7375 34.5967 95.7375C34.5967 95.7375 35.8376 95.7375 35.8849 94.8157C35.9322 93.8939 35.1994 93.9175 34.5967 93.7757C35.0458 93.9648 35.6249 93.5866 35.6367 93.1021C35.6485 92.6175 35.0931 92.2157 34.6322 92.3812C35.4713 92.3694 35.7549 91.8612 35.7076 91.4475C35.5776 90.3839 33.4268 89.4976 32.9895 92.2394H32.9777Z",
    fill: "white",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3545 93.7876V90.4668",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3545 110.664V99.9329",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5388 97.6166C62.8415 100.725 68.266 100.819 71.2677 99.7202",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2363 99.5193C65.1818 102.627 70.878 101.788 73.0762 100.831C75.0616 99.9684 76.7398 98.4202 77.7797 96.5294",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8101 73.4015C55.7392 74.666 55.5501 76.1315 55.4556 77.8214",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2991 43.1002C57.6536 47.0828 61.1045 49.2337 64.1653 49.8837C67.2971 50.5455 72.1188 48.761 73.797 46.2792",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7818 27.0987C53.86 28.1269 53.3872 29.545 53.5054 30.9277C53.6236 32.3104 54.309 33.6222 55.3845 34.4968",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0006 28.1978C58.1615 33.1613 62.1324 35.3949 63.6805 35.2177",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4891 27.666C64.6737 33.3386 68.5264 34.7449 70.4527 34.7568",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5177 29.9468C75.7705 32.4994 76.125 35.4894 75.4868 38.2666C75.1323 39.8148 74.4823 41.3038 74.3168 42.8875C74.1514 44.4711 74.6123 46.2674 75.9714 47.0947",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3493 36.9549L54.3448 39.9094C53.7657 41.6112 53.1866 43.3485 53.1748 45.1448C53.1748 46.4448 53.5175 47.8275 54.4511 48.7375C55.3848 49.6475 57.0275 49.8838 57.9965 49.0211",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2905 21.1779C79.0796 20.6816 81.5613 22.8325 83.334 25.0424C86.7022 29.2142 84.7522 37.4513 85.284 39.9567C85.7567 42.143 86.2295 46.5984 85.2131 48.5957C84.1968 50.5929 81.5968 51.8574 79.6114 50.8411",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7444 45.4402C78.1581 46.5748 77.9454 47.9102 77.189 48.8556C76.4327 49.8011 75.1799 50.3093 73.9863 50.1556C74.0809 50.2147 74.1754 50.2738 74.2818 50.3211",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2533 46.9292C73.2296 49.2219 73.206 51.5264 73.1824 53.8191C73.3478 54.02 73.5251 54.2209 73.6905 54.41",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7045 51.7037C62.6409 51.9637 61.8964 52.9209 61.2346 53.7955C60.5728 54.67 59.7691 55.5918 58.6819 55.7573",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2319 56.0054L66.5764 60.0826",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5515 57.3055C58.5515 57.3055 61.0333 63.6399 62.5105 64.4317C63.9878 65.2235 66.4696 61.489 66.4696 61.489",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6643 44.542C63.8816 44.8375 66.3397 44.6129 66.3397 44.6129C66.3397 44.6129 65.5952 47.3665 63.3025 46.1138",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9681 56.2891C56.9681 56.2891 53.2336 56.8563 51.7682 62.6235C50.421 67.918 48.731 72.7042 47.3601 77.8569",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1598 63.3562C54.9826 65.767 55.2544 68.3079 55.8925 70.3406",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1119 40.0394C60.7254 40.0394 61.2228 39.4997 61.2228 38.8339C61.2228 38.1682 60.7254 37.6285 60.1119 37.6285C59.4983 37.6285 59.001 38.1682 59.001 38.8339C59.001 39.4997 59.4983 40.0394 60.1119 40.0394Z",
    fill: "#313131"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0345 40.2521C69.648 40.2521 70.1454 39.7124 70.1454 39.0467C70.1454 38.3809 69.648 37.8412 69.0345 37.8412C68.4209 37.8412 67.9236 38.3809 67.9236 39.0467C67.9236 39.7124 68.4209 40.2521 69.0345 40.2521Z",
    fill: "#313131"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3737 41.5166L63.1492 42.1548",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2231 69.5253C82.9086 72.3143 82.9322 75.2215 83.4995 82.5605",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0081 30.9395C71.0081 30.9395 71.2799 35.3949 75.1207 36.7658",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1246 88.564C90.0346 87.4413 90.7437 86.165 90.9682 85.1132C91.4291 82.9505 91.1573 80.7051 90.8855 78.5069C89.9873 71.3571 90.3301 54.8119 79.8357 55.4737",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M89.763 112.138C89.4321 112.564 90.1648 118.106 90.342 121.793",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3404 100.512L74.3523 104.211L64.307 111.184L34.0884 107.686L34.1593 97.9594",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6252 96.0448C67.8525 96.293 66.0443 96.3048 64.2716 96.0685C63.8225 96.0094 63.3026 95.8794 63.1371 95.4539C62.9953 95.0758 63.2435 94.6503 63.5862 94.4376C63.9289 94.2249 64.3425 94.2012 64.7443 94.1658C66.1152 94.0712 67.6043 94.1658 68.9634 93.9176C69.2706 93.8585 71.7051 92.8185 71.7051 92.8185C71.6933 92.8185 70.8306 92.2158 68.9161 92.3694C67.9588 92.4522 67.2379 92.2749 66.328 92.0031C64.768 90.8213 70.3933 90.1358 70.9015 90.0531C73.8678 89.5568 75.2505 91.4358 75.2505 91.4358C80.3795 86.4486 80.3441 85.5032 82.1522 83.8605",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8904 84.7705L58.9656 86.295L63.3264 82.6433L49.3103 80.9651L44.8904 84.7705Z",
    fill: "white",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8703 109.6C50.1021 113.323 47.3485 122.576 46.8994 125.188",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M34.207 86.7795L64.2365 90.2895L74.1518 81.9341",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2082 96.0921C63.0427 99.2593 69.1053 98.7393 70.748 97.9711",
    stroke: "#313131",
    strokeWidth: 1.1818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80347 28.0559C5.06346 28.0796 5.18164 28.0914 5.45346 28.0914C5.73709 28.0914 8.60886 28.0205 9.58975 27.985C9.58975 27.2996 9.56611 27.1696 9.51884 26.8623H11.3979C11.3506 27.2405 11.3506 27.3469 11.3506 27.9496C13.1115 27.9496 13.9033 27.9141 14.3288 27.8787V29.6277C13.856 29.5805 13.6433 29.5686 12.4261 29.5686C11.8588 29.5686 11.7879 29.5686 11.3624 29.5686V31.1404C11.6697 31.7077 11.7879 32.2041 11.7879 32.9131C11.7879 34.1068 11.1734 35.1467 10.027 35.8558C9.50703 36.1749 8.90431 36.4231 7.88796 36.7185C7.59251 35.9622 7.35615 35.5722 6.87161 35.0404C7.94705 34.8867 8.54977 34.7095 9.05794 34.3904C9.44793 34.154 9.67248 33.9177 9.84975 33.5513C9.40066 33.9177 9.04612 34.0477 8.41977 34.0477C7.1907 34.0477 6.31617 33.244 6.31617 32.0977C6.31617 30.8804 7.3207 30.0532 8.78613 30.0532C9.12885 30.0532 9.37703 30.0886 9.61339 30.1714V29.8405C9.61339 29.738 9.61339 29.6514 9.61339 29.5805C7.41524 29.6396 5.678 29.7459 4.86256 29.8523L4.81529 28.0323L4.80347 28.0559ZM8.1125 32.0268C8.1125 32.3577 8.40795 32.6059 8.80976 32.6059C9.27066 32.6059 9.61339 32.3341 9.61339 31.9677C9.61339 31.6368 9.34157 31.4123 8.91613 31.4123C8.44341 31.4123 8.1125 31.6722 8.1125 32.0268Z",
    fill: "#0271BC"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9444 27.926C22.7199 28.0678 22.519 28.2332 21.479 29.1669C20.7345 29.805 19.8245 30.5141 18.9854 31.1286C18.7018 31.3414 18.6309 31.4005 18.6309 31.495C18.6309 31.5817 18.9657 31.8692 19.6354 32.3577C20.699 33.1377 21.7863 34.0004 22.8853 34.9695C22.9326 35.0168 23.0508 35.1113 23.2162 35.2295L21.6917 36.7776C21.1481 35.9858 19.6354 34.6386 17.4963 33.0077C16.9645 32.5941 16.7754 32.405 16.6336 32.1332C16.5391 31.9323 16.48 31.6605 16.48 31.4359C16.48 31.0577 16.6218 30.715 16.87 30.4196C17.0236 30.2541 17.1772 30.1123 17.839 29.6159C19.4463 28.4223 20.7935 27.2169 21.1717 26.6496L22.9444 27.9023V27.926ZM22.6017 29.4623C23.0035 29.9232 23.3817 30.4668 23.689 31.0341L22.7081 31.5659C22.3417 30.8805 22.0463 30.4432 21.6208 29.9587L22.6017 29.4623ZM23.9608 28.7532C24.3271 29.155 24.6698 29.6278 25.0598 30.2896L24.1144 30.8096C23.7362 30.1241 23.4171 29.6514 23.039 29.2378L23.9608 28.7532Z",
    fill: "#0271BC"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0424 27.2996C28.6287 28.5169 28.3097 30.5023 28.2388 32.4404L29.0542 32.7122C28.7824 33.6695 28.6406 34.6267 28.6406 35.6904C28.6406 35.8913 28.6406 35.9858 28.676 36.2104L26.8442 36.2931C26.8442 36.0922 26.8442 36.0095 26.797 35.7258C26.5961 34.2958 26.5251 33.374 26.5251 32.3577C26.5251 31.1286 26.6551 29.7932 26.927 28.2569C27.057 27.5123 27.0688 27.4414 27.0806 27.1223L29.0542 27.2878L29.0424 27.2996ZM31.9732 31.9441C31.4887 32.5704 31.2642 33.0313 31.2642 33.4095C31.2642 33.894 31.7487 34.1658 32.6469 34.1658C33.545 34.1658 34.4905 34.0122 35.2941 33.7286L35.4005 35.6076C35.2192 35.6313 34.9199 35.6746 34.5023 35.7376C33.9232 35.8204 33.2732 35.8795 32.6587 35.8795C31.666 35.8795 31.0042 35.7376 30.4605 35.4304C29.8696 35.0876 29.4796 34.4258 29.4796 33.7404C29.4796 33.2204 29.6569 32.6295 29.9878 32.0859C30.1415 31.8377 30.2005 31.7313 30.4842 31.3177L31.9732 31.9441ZM29.8933 28.1032C30.3896 28.2096 30.9569 28.2569 31.7842 28.2569C33.2023 28.2569 34.2423 28.1741 34.9514 27.985L35.0223 29.805C34.9277 29.805 34.8214 29.805 34.2305 29.8759C33.4978 29.9468 32.7178 29.9941 31.9851 29.9941C31.3351 29.9941 30.8033 29.9705 30.1533 29.9114C30.0705 29.9114 29.9996 29.9114 29.846 29.8877L29.8815 28.0914L29.8933 28.1032Z",
    fill: "#0271BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1388_2618",
    x1: 36.9369,
    y1: 13.7088,
    x2: 184.378,
    y2: 13.7088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0271BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF727B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1388_2618",
    x1: 36.9368,
    y1: 22.2887,
    x2: 184.378,
    y2: 22.2887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0271BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF727B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1388_2618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 217,
    height: 118,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtobarai);
export default __webpack_public_path__ + "static/media/atobarai.b149d346d2a0adcd0ddf694b1ac05b6d.svg";
export { ForwardRef as ReactComponent };